import React from 'react';
import PresentationBackground from 'modules/onboarding/common/PresentationBackground';
import StepRegisterProvider from 'context/login/StepRegister';
import SignIn from 'modules/onboarding/sign-in/SignIn';
import TagsProvider from 'context/events/Tags';

function Login() {

    return (
        <TagsProvider>

            <StepRegisterProvider>
                <PresentationBackground
                    ComponentToRender={() => <SignIn />}
                    is='signIn'
                />
            </StepRegisterProvider>
        </TagsProvider>

    )
};

export default Login;

